<section class="hero" [class.hero--without-illustration]="!showIllustration" role="region">
  <header role="banner" class="hero__container">
    <ng-content select="[content]"></ng-content>
  </header>
  <div
    *ngIf="
      showIllustration &&
      (preserveImgMobile || ((isMobileOrTablet$ | async) === false && (isTabletLandscape$ | async) === false))
    "
    class="hero__illustrations"
  >
    <ng-content select="[illustrations]"></ng-content>
  </div>
</section>
